import { BoxProps, Column } from "@hightouch/htui";
import { ReactNode } from "react";

type QueryContainerProps = Omit<
  BoxProps,
  "border" | "borderColor" | "borderRadius" | "boxShadow"
> & {
  /**
   * Use `noShadow` if the parent container requires overflow to be hidden and therefore cuts off any shadows.
   */
  noShadow?: boolean;
};

export const QueryContainer = ({
  noShadow = false,
  children,
  ...props
}: QueryContainerProps) => {
  return (
    <Column
      borderWidth="hairline"
      borderStyle="solid"
      borderColor="base.border"
      borderRadius="xl"
      boxShadow={noShadow ? "none" : "buttonShadowLight"}
      bg="white"
      minWidth={0}
      flex={1}
      overflow="hidden"
      {...props}
    >
      {children}
    </Column>
  );
};

export const QueryContent = ({ children }: { children: ReactNode }) => {
  return (
    <Column p={4} gap={4} overflow="auto">
      {children}
    </Column>
  );
};
